const store =
[
  ["上海市","上海市","15200154","松江区谷阳南路店","上海市松江区谷阳南路28弄22号","15821663375"],
  ["上海市","上海市","15200291","徐汇区清真路店","上海市徐汇区清真路41号","13817154601"],
  ["上海市","上海市","15200313","嘉定区依玛路店","上海市嘉定区依玛路363号","13761495220"],
  ["上海市","上海市","65200320","长宁区长宁路店","上海市长宁区长宁路88号KinG购物中心3层9号","13764304221"],
  ["内蒙古","乌兰察布市","16000258","集宁区恩和路店","内蒙古乌兰察布集宁区恩和路奥威购物广场一层","13947459185"],
  ["内蒙古","包头市","16000024","昆区阿尔丁大街店","内蒙古包头市昆区阿尔丁大街神华亿佰蓝天购物中心","13171466318"],
  ["内蒙古","包头市","16000344","昆区钢铁大街店","内蒙古包头市昆区钢铁大街维多利商厦仙妮蕾德专柜","13224872439"],
  ["内蒙古","呼和浩特市","16000070","新城区呼伦北路店","内蒙古呼和浩特市新城区呼伦北路农业厅高层底店","18604717720"],
  ["内蒙古","呼和浩特市","16000140","新城区呼伦贝尔路店","内蒙古呼和浩特市新城区呼伦贝尔路","13704756953"],
  ["内蒙古","海拉尔市","66000418","海拉尔区中央大街店","内蒙古海拉尔市海拉尔区中央大街华汇购物广场1一层化妆品专区仙妮蕾德专柜","13386235235"],
  ["内蒙古","通辽市","10191299","通辽经济技术开发区建国路店","内蒙古通辽市建国路日升日美购物广场108号","13804751016"],
  ["内蒙古","通辽市","16000299","科尔沁区解放路店","内蒙古通辽市解放路北350号(东方广场步行街北端路西)","13947521892"],
  ["内蒙古","鄂尔多斯市","16000329","东胜区每天百货都市商场店","内蒙古鄂尔多斯市东胜区伊金霍洛东街3号与达拉特北路交汇每天百货都市商场仙妮蕾德专柜","15034896166"],
  ["内蒙古","集宁市","16000319","春天商厦店","内蒙古乌兰察布市集宁区春天商厦","18604844900"],
  ["北京市","北京市","15100018","朝阳区华彩购物中心店","北京市朝阳区望京广顺北大街华彩购物中心","13910000356"],
  ["北京市","北京市","15100031","昌平区宏福水城广场店","北京市昌平区北七家镇宏福水城广场一层","13901199611"],
  ["北京市","北京市","15100139","城乡贸易大厦店","北京市复兴路甲23号城乡贸易大厦1层1AC3号","13911108048"],
  ["北京市","北京市","15100194","石景山区依翠园店","北京市石景山区鲁谷街道银河南街依翠园19号楼底商11-1","13269032828"],
  ["北京市","北京市","15100275","海淀区紫竹花园店","北京市海淀区紫竹院路88号紫竹花园B座1层6号","18601125611"],
  ["北京市","北京市","15100288","西城区西直门南大街店","北京市西城区西直门南大街18号楼一层","13901244737"],
  ["北京市","北京市","15100308","朝阳区世纪东方城店","北京市朝阳区楼梓庄世纪东方城104号楼地商18号","13901207297"],
  ["北京市","北京市","15100356","崇文区广渠门内大街店","北京市崇文区广渠门内大街6号13号楼1层110室","13501398717"],
  ["北京市","北京市","15100356","中国北京王府井旗舰店","北京市东城区王府井大街50号天伦王朝酒店底商仙妮蕾德店铺","(010)65228655 / 17319451050"],
  ["吉林省","吉林市","15700001","昌邑区延安街店","吉林省吉林市昌邑区延安街德威25号楼3号网点（延安路1228号门市房）","13079793928"],
  ["吉林省","吉林市","15700037","昌邑区欧亚商都店","吉林省吉林市解放东路6号欧亚商都仙妮蕾德专柜","13596396095"],
  ["吉林省","吉林市","15700070","船营区解放中路店","吉林省吉林市船营区解放中路120号","13500980527"],
  ["吉林省","吉林市","15700174","昌邑区东昌小区店","吉林省吉林市昌邑区东昌小区13号楼2号网点","13504758479"],
  ["吉林省","吉林市","15700236","昌邑区武昌路店","吉林省吉林市昌邑区武昌路4号楼6号网点","13904410227"],
  ["吉林省","吉林市","15700238","丰满区吉林大街店","吉林省吉林市吉林大街1-2号，吉林欧亚商都综合体","13904417203"],
  ["吉林省","图们市","65700344","仙妮蕾德图们恒昊购物中心店","吉林省图们市向上路419-2号恒昊购物中心2F 9区","13946105021"],
  ["吉林省","延吉市","15700047","延吉百货大楼店","吉林省延吉市光明街608号","18904335553"],
  ["吉林省","延吉市","15700208","新时代购物广场店","吉林省延吉市解放路288号","13304435582"],
  ["吉林省","延吉市","65700345","延吉市太平街店","吉林省延吉市太平街1065－3号（七区）","138-44353268"],
  ["吉林省","延吉市","15700092","明珠购物中心店","吉林省延吉市明珠购物中心","13944391744"],
  ["吉林省","敦化市","45700367","欧亚敦百购物中心店","吉林省敦化市工农路888号欧亚敦百购物中心","15584603888"],
  ["吉林省","松原市","15700145","宁江区金辉街店","吉林省松原市宁江区金辉街227号仙妮蕾德店铺","13943807178"],
  ["吉林省","梅河口市","15700010","欧华商城店","吉林省梅河口市欧华商城1-9号","13596364635"],
  ["吉林省","珲春市","15700195","靖和区靖和街店","吉林省珲春市靖和区靖和街城北征费所南侧","13844353268"],
  ["吉林省","白城市","15700142","洮北区幸福南大街店","吉林省白城市洮北区幸福南大街106号","13804369633"],
  ["吉林省","白山市","15700181","白山广泽国际购物中心店","吉林省白山市八道江区浑江区浑江大街152号白山广泽国际购物中心一层仙妮蕾德专柜","13904501516"],
  ["吉林省","蛟河市","65700359","鑫汇百货大楼店","吉林省蛟河市新华大街26号","15504327203"],
  ["吉林省","长春市","15700090","南关区长春大街店","吉林省长春市南关区长春大街与大马路交汇处1451号仙妮蕾德店铺","13844188865"],
  ["吉林省","长春市","15700096","二道区国贸商都店","吉林省长春市二道区吉林大街与东盛大街交汇处，二道区国贸商都一楼仙妮蕾德专柜","13074379088"],
  ["四川省","德阳市","17100095","长江东路店","四川省德阳市长江东路24号","18980106166"],
  ["四川省","德阳市","17100140","北街大巷子店","四川省德阳市北街大巷子95号","13038282531"],
  ["四川省","成都市","17100065","锦江区致民路店","四川省成都市锦江区致民路34号附17号","15928870848"],
  ["四川省","成都市","17100070","新都镇清源路店","四川省成都市新都镇清源路66号19幢11-12号","13908087682"],
  ["四川省","成都市","17100096","新都区天香西路店","四川省成都市新都区天香西路7-9号","13808227998"],
  ["四川省","成都市","17100125","新都区懿润百货店","四川省成都市新都区新中路77号懿润百货四楼","18681227682"],
  ["四川省","成都市","17100136","武侯区洗面桥街店","四川省成都市武侯区洗面桥街25号附6号","13518117090"],
  ["四川省","眉山市","17100150","东坡区黄州路店","四川省眉山市东坡区黄州路130号-132号","1332-0931601"],
  ["四川省","西昌市","17100014","风情路店","四川省西昌市风情路1号","13778660493"],
  ["四川省","资阳市","17100001","雁江区禾邦商业广场店","四川省资阳市雁江区禾邦商业广场2号楼2110号","13982962878"],
  ["天津市","天津市","15300017","杨柳青镇宝华街店","天津市杨柳青镇宝华街240号","13821763575"],
  ["天津市","天津市","15300061","和平区天津国际商场店","天津市和平区南京路211号天津国际商场B座一层仙妮蕾德专柜","13194690276"],
  ["宁夏","固原市","17600007","原州区五指广场店","宁夏固原市原州区五指广场","13007941788"],
  ["安徽省","宿州市","16300038","墉桥区同盛广场店","安徽省宿州市墉桥区胜利路318号W同盛广场","13805570981"],
  ["安徽省","淮北市","16300143","相山区孟山中路店","安徽省淮北市孟山中路1#104号","15956107965"],
  ["安徽省","界首市","16300108","东城办事处广场店","安徽省界首市东城办事处广场南路A7号商铺","13855828497"],
  ["安徽省","黄山市","16300068","屯溪区黄山东路店","安徽省黄山市屯溪区黄山东路21号维多利亚北苑26幢52","13855938968"],
  ["山东省","临沂市","16201268","兰山区沂蒙路店","山东省临沂市兰山区沂蒙路159号华润万象汇C座307","15266658163"],
  ["山东省","乳山市","16200078","利群购物广场店","山东省乳山市商业街47号（利群购物广场）","18669333899"],
  ["山东省","威海市","16201277","文登区天福路店","山东省威海市文登区天福路19号（天福办）","13869007758"],
  ["山东省","济南市","10194377","高新区经十东路未来创业广场店","山东省济南市高新区经十东路未来创业广场A109号商铺","13335189588"],
  ["山东省","济南市","16200738","高新开发区沁园路店","山东省济南市高新开发区沁园路沁园新居5-105","13335189588"],
  ["山东省","济南市","16200811","历城区七里河路店","山东省济南市华龙路七里河路5号11号门店","18605314627"],
  ["山东省","济南市","16200934","槐荫区阳光新路店","山东省济南市槐荫区阳光新路13号阳光100美乐汇A区1楼","15508637098"],
  ["山东省","济南市","66201512","市中区舜耕路店","山东省济南市市中区舜耕路28号济南华联超市有限公司舜耕店超市内","13905316917"],
  ["山东省","淄博市","16201138","临淄区牛山路店","山东省淄博市临淄区牛山路382甲57号","13355211681"],
  ["山东省","潍坊市","16200986","高新区新城街道鸢都社区店","山东省潍坊市高新区新城街道鸢都社区东风东街以北东方路以东交通银行南20米","13964732083"],
  ["山东省","烟台市","16200560","芝罘区解放路世贸广场店","山东省烟台市芝罘区解放路156号世贸广场一层A116-2号","18653583377"],
  ["山东省","章丘市","16200788","明水区山泉路维华商业广场店","山东省章丘市明水区山泉路维华商业广场","13153136408"],
  ["山东省","青州市","16200525","宋城路店","山东省青州市宋城录8号","13173126189"],
  ["山东省","龙口市","16200689","东莱区港城大道店","山东省龙口市东莱区港城大道","13355457866"],
  ["山西省","原平市","15500099","体育南路店","山西省原平市城区体育南路原平一小市广场对面147号","13834005093"],
  ["山西省","大同市","15500131","平城区柳航新村店","山西省大同市城区柳航新村4-3商铺商","13835205586"],
  ["山西省","大同市","15500260","平城区永泰南路店","山西省大同市平城区永泰南路415号","13934760728"],
  ["山西省","太原市","15500312","迎泽区铜锣湾名品街店","山西省太原市铜锣湾名品街5号","13068074179"],
  ["山西省","平陆县","15500056","平陆县无太阳路店","山西省平陆县无太阳路虞国壹号门面房","18603593203"],
  ["山西省","朔州市","15500142","朔城区建设北路华源万和城店","山西省朔州市朔城区建设北路华源万和城A区29号商铺","15333495319"],
  ["山西省","运城市","15500086","盐湖区恒隆国际购物中心店","山西省运城市盐湖区河东东街恒隆国际购物中心负一层","13935908971"],
  ["山西省","长治市","15500221","解放西路店","山西省长治市城区解放西路海棠4号楼西一号","18635505890"],
  ["山西省","阳泉市","15500179","阳泉滨河新天地商业广场店","山西省阳泉市城区阳泉滨河新天地商业广场二层","13835329555"],
  ["山西省","阳泉市","15500210","金振购物中心店","山西省阳泉市孟县盂县县城广场金振购物中心","13935365198"],
  ["山西省","阳泉市","15500217","臧山北路店","山西省阳泉市孟县臧山北路001","13546139995"],
  ["广东省","中山市","17900200","东区紫马奔腾广场店","广东省中山市东区中山五路2号紫马奔腾广场1座1层02-01卡商铺","13809878082"],
  ["广东省","中山市","17900409","黄圃镇兴圃大道店","广东省中山市黄圃镇兴圃大道西47号首层1-1007之二","13326991839"],
  ["广东省","中山市","17900642","石岐区康华路店","广东省中山市石岐区康华路28号3卡","13702359540"],
  ["广东省","中山市","17900929","小榄镇海港城商业中心店","广东省中山市小榄镇升平东路1号海港城商业中心3楼L329号商铺","13702389421"],
  ["广东省","中山市","67900986","东区远洋广场店","广东省中山市东区博爱六路28号远洋广场3幢大信购物中心二楼2F203商铺","13809873082"],
  ["广东省","佛山市","17900148","顺德区桂洲大道店","广东省佛山市容桂红星居委会桂洲大道中63号天佑城首层1J16","13609011476"],
  ["广东省","佛山市","17900265","南海区桂澜北路店","广东省佛山市南海区桂城街道桂澜北路28号南海万达广场南7栋258号铺","13326752676"],
  ["广东省","佛山市","17900344","顺德区彩虹路店","广东省佛山市顺德区大良德和居委会新城区彩虹路1号","13802488589"],
  ["广东省","佛山市","17900426","南海区大沥乐趣荟广场店","广东省佛山市南海区大沥镇工业大道28号乐趣荟广场首层1039","13923116944"],
  ["广东省","佛山市","17900470","三水区三水万达广场店","广东省佛山市三水区云东海街道南丰大道13号三水万达广场2座2001","188-23099032"],
  ["广东省","佛山市","17900496","南海区活力新城广场店","广东省佛山市南海区佛山市南海区西樵镇西吴村过境路边活力新城广场商铺1F31-01铺","13652274113"],
  ["广东省","佛山市","17900540","南海区桂城南桂西路店","广东省佛山市南海区桂城南桂西路34号（直路口）","13923116911"],
  ["广东省","佛山市","17900580","南海区大沥镇振兴路店","广东省佛山市南海区大沥镇振兴路13号伟业华誉豪庭13栋首层1F31号","13336447038"],
  ["广东省","佛山市","67900962","南海区南海大道店","广东省佛山市南海区南海大道中71号丽雅苑44号商铺","13326752676"],
  ["广东省","佛山市","67900995","南海区桂城超丽综合圣地广场店","广东省佛山市南海区罗源路2号","13923116911"],
  ["广东省","佛山市","67901001","顺德区北滘商业广场店","广东省佛山市北滘镇君兰居委会人昌路10号北滘商业广场首层1F003A号商铺","13802488589"],
  ["广东省","广州市","10185965","增城区增城大道店","广东省广州市增城区荔城街增城大道69号1幢297号二楼2036B商铺","13826139008"],
  ["广东省","广州市","10213084","荔湾区沙面南街店","广东省广州市荔湾区沙面南街1号白天鹅宾馆首层商场内一间自编号B5商铺","18102723840"],
  ["广东省","广州市","17900081","海珠区宝岗大道中广百新一城店","广东省广州市海珠区宝岗大道中广百新一城2楼中庭位置","13926492783"],
  ["广东省","广州市","17900135","花都区曙光路店","广东省广州市花都区曙光路81号1-4层商业(部位:二层2118号铺)","13926210636"],
  ["广东省","广州市","17900604","广州市白云区同和康善美商店","广东省广州市白云区同泰路118号A15-2房","13822214180"],
  ["广东省","广州市","17900701","广州市北京路名盛广场天河城百货店","广东省广州市越秀区北京路238号首层103自编1B45房","13902293517"],
  ["广东省","广州市","17900763","广州市荔湾区西华福满日用品商行","广东省广州市荔湾区康王北路1081号134铺","13660126490"],
  ["广东省","广州市","67900983","荔湾区康王北路店","广东省广州市花都区龙珠路41号凤凰广场A区第二层自编号2-2/3号","13926210636"],
  ["广东省","广州市","67901008","广州市番禺区南村镇番禺万达广场一楼店","广东省广州市番禺区南村镇汉溪大道东(延伸段)385号101房-1035","13926492783"],
  ["广东省","深圳市","17900003","龙华区民治街道店","广东省深圳市龙华区民治街道新牛社区锦绣江南四期3号1025","13828720380"],
  ["广东省","清远市","10160859","清城区人民一路店","广东省清远市清城区人民一路28号 顺盈时代广场商业中心二楼B2133号","13750106825"],
  ["广东省","清远市","17901005","佛冈县振兴路鸿兴银座城店","广东省清远市佛冈县振兴路鸿兴银座城2楼","13750106825"],
  ["广东省","湛江市","17900020","开发区荣基国际广场店","广东省湛江市开发区观海路183号荣基国际广场二楼032号商铺","13828251910"],
  ["广东省","珠海市","67901000","拱北区迎宾广场店","广东省珠海市拱北区拱北迎宾南路1144号迎宾广场二层33B号","13702359540"],
  ["广东省","肇庆市","17900393","端州区端州四路店","广东省肇庆市端州区端州四路8号肇庆印象汇第01-69B商铺","13143359286"],
  ["广东省","肇庆市","17900737","广宁县南街镇城东广场百花商场街店","广东省肇庆市广宁县南街镇城东广场百花商场街","13672370307"],
  ["广东省","英德市","17900001","英城镇和平中路天利时代广场店","广东省英德市英城镇和平中路天利时代广场(合地广场)F2区编号LE005-LE006-1号","13927678574"],
  ["广东省","阳江市","17900291","江城区东风三路店","广东省阳江市江城区东风三路88号阳江盈信广场二层2030号商铺","13719884329"],
  ["广西省","北海市","16900006","海城区市四川路店","广西省北海市海城区市四川路8号A楼第4-5间铺面","13977913333"],
  ["广西省","北海市","66900334","海城区扬名商店","广西省北海市海城区新力商业广场一楼P-1F-49号商铺","13977913333"],
  ["广西省","南宁市","16900071","海城区新力商业广场店","广西省南宁市新城区桂雅路16号东盟中央城A区A4号楼一层B109号","13978839343"],
  ["广西省","南宁市","16900153","江南区那洪大道店","广西省南宁市江南区那洪大道40号华联购物广场1楼","13878868756"],
  ["广西省","南宁市","66900332","青秀区中柬路店","广西省南宁市青秀区中柬路8号南宁龙光商业广场G层09A商铺","13978839343"],
  ["广西省","南宁市","66900333","青秀区东葛路店","广西省南宁市青秀区东葛路82号永凯现代城购物中心中岛1号","13878868756"],
  ["广西省","柳州市","16900027","东环大道店","广西省柳州市东环大道168号翡翠龙庭12栋1-23号","13877252178"],
  ["广西省","贵港市","16900325","港北区民主路店","广西省贵港市港北区民主路69号宏桂城市广场2幢221号","18677511188"],
  ["广西省","钦州市","16900154","钦北区钦州湾大道店","广西省钦州市钦州湾大道82号仟仟万家一楼","13788499088"],
  ["新疆","乌鲁木齐市","17800050","沙依巴克区友好北路店","新疆乌鲁木齐市沙依巴克区友好北路689号","13999222831"],
  ["新疆","乌鲁木齐市","17800058","天山区光明路店","新疆乌鲁木齐市天山区光明路58号金碧华府A栋1层02号商铺","13909927027"],
  ["新疆","乌鲁木齐市","17800130","沙依巴克区克拉玛依东路电","新疆乌鲁木齐市沙依巴克区克拉玛依东路32号","13369682575"],
  ["新疆","伊宁市","17800082","斯大林街店","新疆伊宁市斯大林街六巷边防局门面房","13999585867"],
  ["新疆","克拉玛依市","17800061","克拉玛依市准噶尔商场店","新疆克拉玛依市克拉玛依区准噶尔路准噶尔商场","13619999826"],
  ["新疆","哈密市","17800080","天山东路领先购物广场店","新疆哈密市天山东路86号","18999683299"],
  ["新疆","奎屯市","17800032","乌苏南街友好商场店","新疆奎屯市乌苏南街38-4号","15099214566"],
  ["新疆","库尔勒市","17800007","萨依巴格区青年路征稽大厦店","新疆库尔勒市萨依巴格区青年路征稽大厦03号","13779658811"],
  ["新疆","新源县","17800186","建设街蓝光大厦店","新疆新源县建设街蓝光大厦一楼门面","18099511889"],
  ["新疆","阿克苏市","17800009","西大街迎宾大厦店","新疆阿克苏市西大街迎宾大厦A-9号","13565133876"],
  ["新疆","阿克苏市","17800166","晶水路金石花园店","新疆阿克苏市晶水路金石花园2-13号","13579137818"],
  ["江苏省","南通市","16100579","崇川区万濠华府店","江苏省南通市崇川区万濠华府20幢103室","13773603893"],
  ["江苏省","宿迁市","16100346","宿城区市府东路店","江苏省宿迁市宿城区市府东路门面房甲-1栋342号","13952196199"],
  ["江苏省","常熟市","16100114","虞山镇枫林苑店","江苏省常熟市枫林苑6幢14号","13182698259"],
  ["江苏省","徐州市","10181801","云龙区户部山商城店","江苏省徐州市云龙区户部山商城B4-1-102号","13952196199"],
  ["江苏省","徐州市","15800551","鼓楼区中山北路点","江苏省徐州市鼓楼区铜沛办事处中山北路233号1间","13852480184"],
  ["江苏省","徐州市","16100501","淮海西路店","江苏省徐州市淮海西路252号一层F149","13605217223"],
  ["江苏省","徐州市","16100572","金地百货店","江苏省徐州市云龙区中山北路6号金地百货","13905219196"],
  ["江苏省","徐州市","66100723","解放南路店","江苏省徐州市解放南路26-8号","13952196199"],
  ["江苏省","扬州市","16100364","邗江区竹西路店","江苏省扬州市邗江区竹西路31号","15952790006"],
  ["江苏省","扬州市","16100367","邗江区文昌中路店","江苏省扬州市邗江区文昌中路618号中集文昌商业中心3号楼1层115铺","13101851418"],
  ["江苏省","溧阳市","16100342","平陵广场西大街店","江苏省溧阳市平陵广场西大街3-261","13961243368"],
  ["江西省","南昌市","17000034","红谷滩新区万达广场店","江西省南昌市红谷滩新区万达广场A区商业楼1-2004","18070113380"],
  ["江西省","新余市","17000014","公园北路高能广场店","江西省新余市公园北路高能广场二楼","13879006087"],
  ["河北省","任丘市","15400526","任丘市欣之康商店","河北省任丘市华北区华北石油潜山道金地花园东门","13780277868"],
  ["河北省","保定市","15400023","北市区东风中路店","河北省保定市北市区东风中路72号","13932295567"],
  ["河北省","保定市","15400134","新市区天鹅中路店","河北省保定市新市区天鹅中路279号","15031299619"],
  ["河北省","保定市","15400222","莲池区恒祥北大街店","河北省保定市莲池区恒祥北大街206号","13703288228"],
  ["河北省","保定市","15400263","蠡县范蠡东路店","河北省保定市蠡县范蠡东路","13582070868"],
  ["河北省","保定市","15400291","新市区七一中路店","河北省保定市新市区七一中路1266号","13764304221"],
  ["河北省","保定市","15400730","北市区七一东路店","河北省保定市北市区七一东路224号","13082389662"],
  ["河北省","保定市","15400742","竞秀区天威西路店","河北省保定市竞秀区天威西路268号","15031289186"],
  ["河北省","保定市","65400770","高新区朝阳北大街店","河北省保定市高新区朝阳北大街799号北国先天下-1层","13932295567"],
  ["河北省","唐山市","15400216","路北区光明东路甲九楼店","河北省唐山市路北区48号小区光明东里甲九楼底商05号","15612521916"],
  ["河北省","唐山市","15400444","路南区南湖购物广场店","河北省唐山市路南区唐山百货大楼南湖购物广场西电路42-1","13731434419"],
  ["河北省","唐山市","15400672","迁西县凤凰东街店","河北省唐山市迁西县凤凰东街22号楼","18231543743"],
  ["河北省","唐山市","65400782","迁西县景忠西街店","河北省唐山市迁西县景忠西街55号","18231543743"],
  ["河北省","容城县","15400308","容城县永贵南大街店","河北省容城县永贵南大街新容花园小区店铺155号","13513288066"],
  ["河北省","廊坊市","15400662","广阳区新世纪步行街店","河北省廊坊市广阳区新世纪步行街四大街A_231","13603168616"],
  ["河北省","张家口市","15400325","桥东区胜利北路店","河北省张家口市桥东区胜利北路30-0-3号","13722337189"],
  ["河北省","张家口市","15400328","宣化区名门华府店","河北省张家口市宣化区名门华府底商","13833315255"],
  ["河北省","承德市","15400210","双滦区秀水大街店","河北省承德市双滦区秀水大街","13731429713"],
  ["河北省","承德市","65400772","双桥区都统府大街店","河北省承德市双桥区都统府大街1号","13731429713"],
  ["河北省","晋州市","15400649","晋州市光明路店","河北省晋州市光明路","13383318521"],
  ["河北省","涿州市","15400181","双塔区朝阳路店","河北省涿州市双塔区朝阳路槐林小区12号","13930892686"],
  ["河北省","石家庄市","15400105","桥东区谈北路冠城店","河北省石家庄市桥东区谈北路冠城2号底商7号","15383314162"],
  ["河北省","石家庄市","15400355","桥东区光华路店","河北省石家庄市桥东区光华路7号","13073157271"],
  ["河北省","石家庄市","15400477","桥西区工农路缔景城店","河北省石家庄市桥西区工农路缔景城底商1022","13513118916"],
  ["河北省","石家庄市","15400540","新华区新华路天林大厦店","河北省石家庄市新华区新华路天林大厦A座6号","13903115064"],
  ["河北省","秦皇岛市","10182601","海港区文化路店","河北省秦皇岛市海港区文化路363-2号门市仙妮蕾德专卖店","13833537457"],
  ["河北省","秦皇岛市","15400423","海港区建设大街店","河北省秦皇岛市海港区建设大街248号一层","13903349155"],
  ["河北省","秦皇岛市","65400791","河北大街店","河北省秦皇岛市河北大街150号","3233744 "],
  ["河北省","遵化市","65400751","华明北路店","河北省遵化市华明北路82号","13313255385"],
  ["河北省","邯郸市","15400296","邯山区陵园路店","河北省邯郸市邯山区陵园路34-3号万浩家园一期底商","13603200338"],
  ["河北省","鹿泉市","15400104","获鹿镇北斗路店","河北省鹿泉市获鹿镇北斗路水利局回迁楼","13933028112"],
  ["河南省","南阳市","15800253","卧龙区七一路怡博城市花园店","河南省南阳市卧龙区七一路怡博城市花园一楼门面","13937717088"],
  ["河南省","南阳市","15800473","卧龙区中州中路世纪百货店","河南省南阳市卧龙区中州中路","13937788397"],
  ["河南省","新乡市","15800380","红旗区胜利路天王百货店","河南省新乡市红旗区胜利路212号","13603738226"],
  ["河南省","新密市","15800123","府西街店","河南省新密市府西街","13592614281"],
  ["河南省","新郑市","10206848","人民路店","河南省新郑市人民路与中华路交叉口西南角新郑市委对面","18103821880"],
  ["河南省","濮阳市","15800288","玉门路店","河南省濮阳市玉门路6号","13939359206"],
  ["河南省","郑州市","15800019","二七区兴华南街店","河南省郑州市二七区兴华南街","13837152267"],
  ["河南省","郑州市","15800106","索河路店","河南省郑州市荥阳市索河路中段","1367690017"],
  ["河南省","郑州市","15800119","二七区交通路淮河路店","河南省郑州市交通路淮河路6-2","18638774952"],
  ["河南省","郑州市","15800192","金水区黄河路店","河南省郑州市金水区黄河路18号-3号","13837184199"],
  ["河南省","郑州市","15800259","金水区纬一路店","河南省郑州市金水区纬一路与经七路交叉口省军区礼堂后门东侧","13903815871"],
  ["河南省","郑州市","15800290","中原区嵩山北路店","河南省郑州市中原区嵩山北路226号--1号","15638201527"],
  ["河南省","郑州市","15800470","二七区陇海中路店","河南省郑州市二七区陇海中路100号鑫苑鑫都会","13203811671"],
  ["浙江省","台州市","16400507","经济开发区市府大道店","浙江省台州市经济开发区市府大道289号耀达百货-1F","13305862588"],
  ["浙江省","嘉兴市","16400414","国际中港商贸城店","浙江省嘉兴市广益路555号国际中港商贸城A区一楼A17号","13857395365"],
  ["浙江省","杭州市","16400352","临安区锦城街道城中街店","浙江省杭州市临安区锦城街道城中街1103号","13968030217"],
  ["浙江省","杭州市","16400459","上城区孝女路店","浙江省杭州市上城区孝女路7-2号(7号102室)","13906521803"],
  ["浙江省","永康市","46400774","江南街道华丰东路店","浙江省永康市江南街道华丰东路45号","13588603540"],
  ["浙江省","温州市","16400145","江滨西路东门步行街店","浙江省温州市鹿城区江滨西路东门步行街41号 43号","13706622166"],
  ["浙江省","诸暨市","10165315","暨阳街道永兴路店","浙江省诸暨市暨阳街道永兴路3号","15825472931"],
  ["海南省","海口市","10211240","龙华区城西镇新城吾悦广场店","海南省海口市龙华区城西镇新城吾悦广场S1-106商铺","13976478077"],
  ["海南省","海口市","16800009","万国大都会店","海南省海口市大同路24号万国大都会L层089ACDE柜","13006096993"],
  ["海南省","海口市","16800058","龙华区玉沙路店","海南省海口市龙华区玉沙路21号玉沙京华城2FA037-2号铺位","13976478077"],
  ["湖北省","宜昌市","16600211","西陵区西陵二路店","湖北省宜昌市西陵区西陵二路33号","15671011633"],
  ["湖北省","武汉市","16600061","江岸区大智路店","湖北省武汉市江岸区大智路123号大智公寓C栋2号","13237171687"],
  ["湖北省","武汉市","16600065","江汉区万松园横路店","湖北省武汉市江汉区万松园横路3-5号108号","13971328511"],
  ["湖南省","长沙市","16700005","雨花区左家塘营山巷店","湖南省长沙市雨花区左家塘营山巷5号门面","13973111717"],
  ["湖南省","长沙市","16700059","雨花区韶山中路店","湖南省长沙市雨花区韶山中路495号万博会商业街二层220号","13017180007"],
  ["甘肃省","兰州市","17500034","城关区天水南路店","甘肃省兰州市城关区天水南路218号","13893247349"],
  ["甘肃省","兰州市","17500053","城关区庆阳路店","甘肃省兰州市城关区庆阳路111号","13919270060"],
  ["甘肃省","金昌市","17500022","金川区盘旋路店","甘肃省金昌市金川区盘旋路上层领地购物中心","18909456601"],
  ["福建省","厦门市","16500124","思明区厦禾路店","福建省厦门市思明区厦禾路628-102(肯德基旁)","18650000139"],
  ["福建省","福州市","16500015","晋安区泰禾城市广场店","福建省福州市晋安区岳峰镇竹屿路6号东二坏泰禾城市广场（二期）21#楼2层16商铺","13075849988"],
  ["福建省","福清市","46500233","音西街道万达广场店","福建省福清市音西街道万达广场室内步行街","13305008210"],
  ["贵州省","贵阳市","17200011","云岩区中山西路店","贵州省贵阳市云岩区中山西路恒峰步行街A区3楼A9.A11号","13312240653"],
  ["辽宁省","丹东市","15600127","元宝区江城大街店","辽宁省丹东市元宝区江城大街276号-2","13604155566"],
  ["辽宁省","大连市","10213353","中山区长江东路店","辽宁省大连市中山区长江东路号80号凯丹广场","18647427717"],
  ["辽宁省","庄河市","15600328","世纪大街北京华联店","辽宁省庄河市城关街道世纪大街北京华联二层F2-3、4区","15140386131"],
  ["辽宁省","抚顺市","15600101","新抚区东一路店","辽宁省抚顺市新抚区东一路24号","13904138583"],
  ["辽宁省","本溪市","10213356","明山区地工路店","辽宁省本溪市明山区地工路18-6栋-1层2门","15104148448"],
  ["辽宁省","沈阳市","15600002","浑南区沈营路店","辽宁省沈阳市浑南区沈营路8号","15940359595"],
  ["辽宁省","沈阳市","15600105","铁西区建设中路店","辽宁省沈阳市铁西区建设中路52号天空之城","13940551083"],
  ["辽宁省","沈阳市","15600165","沈河区市府大路店","辽宁省沈阳市沈河区市府大路256-14号","15940032000"],
  ["辽宁省","沈阳市","15600229","沈河区西顺城街店","辽宁省沈阳市沈河区西顺城街52号","13904013611"],
  ["辽宁省","沈阳市","15600475","皇姑区牡丹江街店","辽宁省沈阳市皇姑区牡丹江街9-1号2门","13940080259"],
  ["辽宁省","沈阳市","15600483","铁西区南六中路店","辽宁省沈阳市南六中路54号","13840529607"],
  ["辽宁省","沈阳市","15600571","铁西区兴工南街店","辽宁省沈阳市铁西区兴工南街36-1号4门","13998245513"],
  ["辽宁省","沈阳市","65600600","皇姑区崇山中路店","辽宁省沈阳市皇姑区崇山中路77号1门","13940080259"],
  ["辽宁省","沈阳市","65600602","和平区北三经街店","辽宁省沈阳市和平区北三经街10甲","02422516560"],
  ["辽宁省","葫芦岛市","15600294","龙港区飞天购物广场店","辽宁省葫芦岛市龙港区龙湾大街43号飞天购物广场一层F1013-1015仙妮蕾德","13304293919"],
  ["辽宁省","辽阳市","10235160","白塔区卫国路店","辽宁省辽阳市白塔区卫国路梧桐雅居92号","13841954199"],
  ["辽宁省","锦州市","65600596","太和区凌南东里科技路店","辽宁省锦州市太和区凌南东里宝地城C区42–45","13940662088"],
  ["辽宁省","鞍山市","15600020","铁西区人民路","辽宁省鞍山市铁西区人民路106号","13998080836"],
  ["辽宁省","鞍山市","15600102","铁东区千山中路店","辽宁省鞍山市铁东区千山中路34-7","13942299895"],
  ["辽宁省","鞍山市","15600570","铁东区园林路店","辽宁省鞍山市铁东区园林路1-32","13804224858"],
  ["重庆市","重庆市","18300012","大渡口区步行街新世纪百货店","重庆市大渡口区步行街新世纪百货裙楼3楼6、7号","13983841359"],
  ["陕西省","宝鸡市","17400029","宝鸡市渭滨区仙丽草本养生馆","陕西省宝鸡市宝鸡市经二路114号宝商百货","13991750586"],
  ["陕西省","渭南市","17400033","临渭区北欧步行街店","临渭区西二路北段北欧步行街一楼仙妮蕾德专卖店","18691378099"],
  ["陕西省","渭南市","17400066","临渭区广场南路红帆广场店","陕西省渭南市临渭区广场南路红帆广场一层仙妮蕾德","13909131146"],
  ["陕西省","西安市","17400038","新城区解放路店","陕西省西安市新城区解放路103号一层仙妮蕾德","13324501279"],
  ["陕西省","西安市","17400041","碑林区南关正街店","陕西省西安市碑林区南关正街88号长安国际王府井百货三层仙妮蕾德","18691952355"],
  ["黑龙江省","哈尔滨市","15900022","南岗区征仪路店","黑龙江省哈尔滨市南岗区征仪路415号","13804507065"],
  ["黑龙江省","哈尔滨市","15900085","红旗大街艺汇家文化商业广场店","黑龙江省哈尔滨市红旗大街240号","13945016212"],
  ["黑龙江省","哈尔滨市","15900100","道里区安阳路店","黑龙江省哈尔滨市道里区安阳路113号","15945995190"],
  ["黑龙江省","哈尔滨市","15900233","道里区群力大道店","黑龙江省哈尔滨市道里区群力大道1176号远大购物广场C1-3-10门仙妮蕾","13796794949"],
  ["黑龙江省","哈尔滨市","15900489","仙妮蕾德哈尔秋林国际购物中心店","黑龙江省哈尔滨市南岗区东大直街320号秋林国际购物中心二楼","13946105021"],
  ["黑龙江省","哈尔滨市","65900264","南岗区一曼街店","黑龙江省哈尔滨市南岗区一曼街78号","13936134178"],
  ["黑龙江省","哈尔滨市","66100748","群力新区银泰城商业中街店","黑龙江省哈尔滨市群力新区银泰城商业中街Z022门","13904608143"],
  ["黑龙江省","大庆市","15900044","让胡路区中原路店","黑龙江省大庆市让胡路区中原路3号，松雷商场一层","13904890966"],
  ["黑龙江省","牡丹江市","15900071","爱民区宝兴购物广场店","黑龙江省牡丹江市爱民区北安路地明街","13936531233"],
  ["黑龙江省","肇东市","65900470","龙升商场店","黑龙江省肇东市正阳7道街109号","18246858321"],
  ["黑龙江省","肇州县","15900007","香榭丽商场店","黑龙江省肇州县油田北路与八厂东街交汇002号香榭丽商场","18246858321"],
  ["黑龙江省","集贤县","15900191","福双路体育街店","黑龙江省集贤县福双路体育街人民医院住宅楼109号","13555167227"],
  ["黑龙江省","鸡西市","65900472","鸡冠区红军街店","黑龙江省鸡西市鸡冠区红军街71号大商集团鸡西新玛特广益街购物广场有限公司","13804507065"],
  ["黑龙江省","黑河市","15900200","爱辉区兴华街店","黑龙江省黑河市爱辉区兴华街东六小南","13845631270"],
  ["黑龙江省","齐齐哈尔市","15900111","富拉尔基区和平大街店","黑龙江省齐齐哈尔市富拉尔基区和平大街81号第五百货","13796335866"]
]

export default store
